import { render, staticRenderFns } from "./SalesForecastInputEdit.vue?vue&type=template&id=f2b8ea28&scoped=true"
import script from "./SalesForecastInputEdit.vue?vue&type=script&lang=js"
export * from "./SalesForecastInputEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b8ea28",
  null
  
)

export default component.exports